import { apiCall } from '../../services/initiation';

const fileExtensionPattern = /\.[^.]+$/;

export default class MediaService {
  constructor(Storage, API, graphqlOperation) {
    this.Storage = Storage;
    this.API = API;
    this.graphqlOperation = graphqlOperation;
  }

  async store(accessType, file) {
    file = await this.normalizeDocument(file);
    const key = encodeURIComponent(this.generateFileName(file));
    const stored = await this.Storage.put(key, file, {
      contentType: file.type,
      level: accessType,
    });
    return stored;
  }
  // Get proposition images for example
  async getProtectedFile(identity, file, key) {
    const retrieved = await this.Storage.get(key, {
      level: 'protected',
      identityId: identity, // the identityId of that user
    });
    return retrieved;
  }
  async getPrivateFileAdmin(identity, file) {
    // Can only be invoked from our IP
    const retrieved = await this.Storage.get(file, {
      level: 'private',
      identityId: identity, // the identityId of that user
    });
    return retrieved;
  }
  async getPrivateFile(file) {
    const retrieved = await this.Storage.get(file, {
      level: 'private',
    });
    return retrieved;
  }

  // eslint-disable-next-line class-methods-use-this
  generateFileName(file) {
    const name = file.name.replace(/[^a-z0-9.]/gi, '').toLowerCase();
    const timestamp = `&#timestamp${Date.now()}`;
    const randomSuffix = Math.floor(Math.random() * 10 + 1);
    const extension = file.name.toLowerCase().match(fileExtensionPattern)[0];
    return `${name}${timestamp}-${randomSuffix}${extension}`;
  }

  // eslint-disable-next-line class-methods-use-this
  async normalizeDocument(file) {
    if (file.type === 'application/pdf') {
      return file;
    }

    const fd = new FormData();
    fd.append('file', file);

    const response = await fetch(
      `${process.env.REACT_APP_NORMALIZER_URL}/normalized-documents`,
      {
        method: 'POST',
        body: fd,
      }
    );

    if (!response.ok) {
      throw new Error('could not normalize document');
    }

    const blob = await response.blob();

    blob.lastModifiedDate = new Date();
    blob.name = file.name.replace(fileExtensionPattern, '.jpg');

    return blob;
  }

  // Folder is gotten from Auth.credentials._identityId
  async storePrivateFile(applicantId, file, folder, type) {
    // Types are: MIN_UC, ID_PROOF, INCOME_BASE, RENTAL_AGREEMENT, RENTAL_BASE
    const types = [
      'MIN_UC',
      'ID_PROOF',
      'INCOME_BASE',
      'RENTAL_AGREEMENT',
      'RENTAL_BASE',
    ];
    if (types.includes(type)) {
      try {
        const res = await this.store('private', file);
        const { key: fileName } = res;

        console.log('Upload to aws response: ', res);

        const response = await apiCall(
          this.graphqlOperation(`mutation {
        uploadDocument(document: {
          applicantId: "${applicantId}"
          fileName: "${fileName}"
          type: ${type}
          folder: "${folder}"
        }){
          folder
          fileName
        }
      }`)
        );
        return response;
      } catch (e) {
        console.log(e);
      }
    }

    throw new Error(
      `Error in variable type: expected MIN_UC, ID_PROOF, INCOME_BASE, RENTAL_AGREEMENT, RENTAL_BASE, but got ${type}`
    );
  }

  // Folder is gotten from Auth.credentials._identityId
  async replacePrivateFile(documentId, applicantId, file) {
    const { key: fileName } = await this.store('private', file);
    const response = await apiCall(
      this.graphqlOperation(`mutation {
      replaceDocument(
        documentId: "${documentId}"
        applicantId: "${applicantId}"
        fileName: "${fileName}"
      ){
        folder
        fileName
        approvalStatus{
          type
        }
      }
    }`)
    );
    return response;
  }

  // Base of how it will work in the future
  // Probably make scaling etc, and store all images needed
  async storePropositionImage(file, key, propositionId) {
    const propositionKey = `proposition/${propositionId}/${key}`;
    const stored = await this.store('protected', file, propositionKey);
    return stored;
  }
}



// WEBPACK FOOTER //
// ./src/components/FileUploader/media.js